import {Component, Inject, OnInit} from '@angular/core';
import {MD_DIALOG_DATA, MdDialogRef} from '@angular/material';

@Component({
  selector: 'app-failed-delete-item-dialog',
  templateUrl: './failed-delete-item-dialog.component.html',
  styleUrls: ['./failed-delete-item-dialog.component.scss']
})

export class FailedDeleteItemDialogComponent {
    constructor(public dialogRef: MdDialogRef<FailedDeleteItemDialogComponent>,
                @Inject(MD_DIALOG_DATA) public data: any
    ) {
        this.createForm();
    }
    /**
     * Creates the delete confirmation form
     */
    createForm() {
    }
    /**
     * Closes the form and returns the ID of the item to be deleted
     */
    onSubmit() {
        this.dialogRef.close();
    }
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/utilities/components/failed-delete-item-dialog/failed-delete-item-dialog.component.ts